let navigator: ((path: string) => void) | null = null;

// Store the navigation function globally
export const setNavigator = (navFn: (path: string) => void) => {
  navigator = navFn;
};

// Call navigation from anywhere
export const navigateTo = (path: string) => {
  if (navigator) {
    navigator(path);
  } else {
    console.warn("Navigator has not been set. Call setNavigator in App.tsx");
  }
};
